import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

const { onRequest, onSuccess, onFailure } = rootActions.quotations.staticEnums

function* staticEnumsQuotationsSagaTask() {
    try {
        const response = yield axios.get(`/companies/quotations/static-enums`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* staticEnumsQuotationsSaga(): any {
    yield takeLatest(onRequest, staticEnumsQuotationsSagaTask)
}

export default staticEnumsQuotationsSaga
